module.exports = "<div seedelement>\n  <div class=\"lui-navigation__productlogo\">\n    <slot name=\"productlogo\">\n      <lui-productlogo>HERE</lui-productlogo>\n    </slot>\n  </div>\n\n  <div class=\"lui-navigation__main\">\n    <slot></slot>\n  </div>\n\n  <slot name=\"controls\"></slot>\n  <slot name=\"controls-mobile\"></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-navigation/theme/lui-navigation.html
// module id = 255
// module chunks = 0 1 9